import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './stylesheets/reset.scss'
import BaiduMap from 'vue-baidu-map';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css';
Vue.use(BaiduMap, {ak: 'tIaPdK5tGiI9j3MVMaPYu612Qpj78HTm'});
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App),

}).$mount('#app')
